import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Typography, Link, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import BarChartIcon from '@mui/icons-material/BarChart';
import { dataDashboards } from '../data/data_dashboards';
import { getDashboardIcon } from '../components/DashboardIcon';

const BreadcrumbsNav = ({ chartTitle, dashboardId }) => {
    const [dashboard, setDashboard] = useState(null);

    useEffect(() => {
        if (dashboardId) {
            dataDashboards.loadDashboard(dashboardId)
                .then(result => {
                    if (result && result.dashboard) {
                        setDashboard(result.dashboard[0]);
                    }
                })
                .catch(error => {
                    console.error('Error loading dashboard:', error);
                });
        }
    }, [dashboardId]);

    return (
        <Box sx={{ px: 3, py: 2 }}>
            <Breadcrumbs aria-label="breadcrumb">
                <Link component={RouterLink} to={`/dashboard/${dashboardId}`} sx={{ display: 'flex', alignItems: 'center' }}>
                    {dashboard?.icon ? getDashboardIcon(dashboard.icon) : <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />}
                    {dashboard?.dashboard_name || 'Dashboard'}
                </Link>
                <Typography sx={{ display: 'flex', alignItems: 'center' }} color="text.primary">
                    <BarChartIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                    {chartTitle || 'Chart Details'}
                </Typography>
            </Breadcrumbs>
        </Box>
    );
};

export default BreadcrumbsNav;
